/**
 * This file is auto-generated from CountryInput.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const countryLabel: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Country';
        case 'pl':
            return 'Kraj';
    }
};

export const selectCountry: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Select a country';
        case 'pl':
            return 'Wybierz kraj';
    }
};
